/*
 * Constant list of all the tiles index, to easily use them in ordder to create the layout
 * See the template file for a clear example of how the tiles are placed
 */
export const tilesize = 16;
export const tilesets = [
    'assets/kenney_tilemap_white.png', // Dark world : white on black
    'assets/kenney_tilemap_black.png', // Light world : black on white
];
export const tilesheets = {
    DARK: 0,
    LIGHT: 1
};
export const tiles = {};
